import { normalizeSwedishPhone, formatSwedishPhone } from './phoneUtils';

export interface MenuItem {
  id: string;
  day: string;
  dish: string;
  dish2?: string;
  vegetarian: string;
  closed?: boolean;
  comment?: string;
}

export interface WeekMenu {
  week: number;
  year: number;
  items: MenuItem[];
}

export interface LunchCard {
  id: string;
  phoneNumber: string;
  remaining: number;
  purchaseDate: string;
}

export interface CompanyCard {
  id: string;
  companyName: string;
  contactPerson: string;
  email: string;
  phoneNumber: string;
  reference?: string;
  total: number;
  remaining: number;
  paymentMethod: "invoice" | "card";
  purchaseDate: string;
}

// Sample data for demo
export const sampleMenus: WeekMenu[] = [

  {
    week: 12,
    year: 2026,
    items: [
      {
        id: "21",
        day: "Måndag",
        dish: "Korv stroganoff med ris",
        dish2: "Isterband med dillstuvad potatis",
        vegetarian: "Vegetarisk stroganoff",
        comment: ""
      },
      {
        id: "22",
        day: "Tisdag",
        dish: "Ugnsstekt kyckling med rosmarinspotatis",
        dish2: "Fiskgratäng med räkor och dill",
        vegetarian: "Vegetarisk gratäng med broccoli och ost",
        comment: ""
      },
      {
        id: "23",
        day: "Onsdag",
        dish: "Biff med bambuskott och stekta nudlar",
        dish2: "Sötstark kyckling med ris",
        vegetarian: "Wokade grönsaker med nudlar",
        comment: "Asiatiskt tema"
      },
      {
        id: "24",
        day: "Torsdag",
        dish: "Ärtsoppa och pannkakor",
        dish2: "Pannkakor med sylt och grädde",
        vegetarian: "Vegetarisk ärtsoppa",
        comment: "Torsdagsklassiker"
      },
      {
        id: "25",
        day: "Fredag",
        dish: "Helstekt fläskfilé med potatisgratäng och rödvinssås",
        dish2: "Panerad rödspätta med remouladsås",
        vegetarian: "Vegetarisk schnitzel med potatisgratäng",
        comment: ""
      }
    ]
  },
  {
    week: 11,
    year: 2026,
    items: [
      {
        id: "26",
        day: "Måndag",
        dish: "Pastagratäng med köttfärs och mozzarella",
        dish2: "Panerad spätta med tartarsås",
        vegetarian: "Vodkapasta",
        comment: ""
      },
      {
        id: "27",
        day: "Tisdag",
        dish: "Stekt fläsk med raggmunk / bruna bönor",
        dish2: "Kyckling parmesan med timjan och ris",
        vegetarian: "Vegetarisk linsstroganoff med ris",
        comment: ""
      },
      {
        id: "28",
        day: "Onsdag",
        dish: "Nattbakad karré med gräddsås och stekt potatis",
        dish2: "Fiskgratäng med potatismos",
        vegetarian: "Krämig champinjonsoppa",
        comment: ""
      },
      {
        id: "29",
        day: "Torsdag",
        dish: "Kotlettrad med rosepepparsås och pommes frites",
        dish2: "Rotmos med fläskkorv",
        vegetarian: "Pastagratäng med bönor och soltorkade tomater",
        comment: ""
      },
      {
        id: "30",
        day: "Fredag",
        dish: "Grillbuffé",
        dish2: "",
        vegetarian: "Vegetariskt alternativ",
        comment: ""
      }
    ]
  }
];

// Deprecated: Använd getCurrentWeekInfo() från dateUtils.ts istället
export { getCurrentWeekInfo, getCurrentDayName, isWeekday } from './dateUtils';

export const generateQRData = (phoneNumber: string): string => {
  const normalized = normalizeSwedishPhone(phoneNumber) || phoneNumber.replace(/\D/g, '');
  return `LUNCHCARD|${normalized}`;
};

export const generateCompanyQRData = (phoneNumber: string): string => {
  const normalized = normalizeSwedishPhone(phoneNumber) || phoneNumber.replace(/\D/g, '');
  return `COMPANYCARD|${normalized}`;
};

export const MOCK_CARD: LunchCard = {
  id: "mock-card-001",
  phoneNumber: "0700000000",
  purchaseDate: "2026-01-01T08:00:00.000Z",
  remaining: 10
};

export const MOCK_COMPANY_CARD: CompanyCard = {
  id: "company-test-001",
  companyName: "Testföretaget AB",
  contactPerson: "Testperson",
  email: "test@foretag.se",
  phoneNumber: "0701112233",
  reference: "Demo",
  total: 50,
  remaining: 50,
  paymentMethod: "invoice",
  purchaseDate: "2026-01-01T09:00:00Z"
};

// Re-exportera för bakåtkompatibilitet
export const formatPhoneNumber = formatSwedishPhone;
export { normalizeSwedishPhone, isValidSwedishPhone } from './phoneUtils';
